module.exports = __webpack_public_path__ + "img/3f_r_pepper@2x.ba4f78a8.jpg";